import React from 'react';
import { Award, Target, Clock, Leaf, BadgeCheck, ShieldCheck } from 'lucide-react';
import { whyChooseUs, companyInfo, certifications } from '../data/mock';

const iconMap = {
  Award: Award,
  Target: Target,
  Clock: Clock,
  Leaf: Leaf,
  BadgeCheck: BadgeCheck,
  ShieldCheck: ShieldCheck,
};

const WhyChooseUsSection = () => {
  return (
    <section id="why-us" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content Side */}
          <div>
            <span className="text-brand font-semibold text-sm tracking-wider uppercase mb-4 block">
              Why Choose Us
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-6">
              Lincolnshire's Trusted Pest Control Experts
            </h2>
            <p className="text-neutral-600 mb-8 text-lg leading-relaxed">
              Led by founder <span className="text-brand font-semibold">{companyInfo.founder}</span> with
              over {companyInfo.experience} years of experience, {companyInfo.fullName} delivers
              professional pest control you can trust. As bed bug specialists, we combine
              expertise with eco-friendly methods for lasting results.
            </p>

            {/* Certifications */}
            <div className="bg-neutral-50 border border-neutral-200 rounded-2xl p-6 mb-6">
              <h4 className="text-neutral-900 font-semibold mb-4">Accredited Member Of:</h4>
              <div className="flex flex-wrap items-center gap-6">
                {certifications.map((cert) => (
                  <div key={cert.name} className="bg-white border border-neutral-200 rounded-lg p-3 hover:scale-105 transition-transform duration-300 shadow-sm">
                    <img 
                      src={cert.logo} 
                      alt={cert.altText}
                      className="h-12 w-auto object-contain"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Insurance Info */}
            <div className="bg-brand/10 border border-brand/30 rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <ShieldCheck className="w-6 h-6 text-brand" />
                <h4 className="text-neutral-900 font-semibold">Fully Insured for Your Peace of Mind</h4>
              </div>
              <div className="grid sm:grid-cols-2 gap-4">
                <div className="bg-white rounded-lg p-4 shadow-sm">
                  <p className="text-brand text-2xl font-bold">£5 Million</p>
                  <p className="text-neutral-600 text-sm">Public Liability Cover</p>
                </div>
                <div className="bg-white rounded-lg p-4 shadow-sm">
                  <p className="text-brand text-2xl font-bold">£500,000</p>
                  <p className="text-neutral-600 text-sm">Professional Indemnity</p>
                </div>
              </div>
            </div>
          </div>

          {/* Features Grid */}
          <div className="grid sm:grid-cols-2 gap-6">
            {whyChooseUs.map((item, index) => {
              const IconComponent = iconMap[item.icon] || Award;
              return (
                <div
                  key={index}
                  className="bg-white border border-neutral-200 rounded-xl p-5 hover:border-brand/30 hover:shadow-lg transition-all duration-300 group"
                >
                  <div className="w-12 h-12 bg-brand/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-brand/20 transition-colors duration-300">
                    <IconComponent className="w-6 h-6 text-brand" />
                  </div>
                  <h4 className="text-neutral-900 font-semibold mb-2">{item.title}</h4>
                  <p className="text-neutral-600 text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
